export default {
  groupButton: {
    buy: 'BUY',
    sell: 'SELL',
  },

  tabs: {
    balanceSheet: 'Balance sheet',
    incomeStatement: 'Income Statement',
    cashFlowStatement: 'Cash flow statement',
  },
  timeTab: {
    quarterly: 'Quarterly',
    yearly: 'Yearly',
  },
  bankTab: {
    nonBank: 'NonBank',
    bank: 'Bank',
  },
  unitBillion: 'Bn.',
  headerPDF: 'COMPANY SNAPSHOT',
  footerText: 'FiinGroup Corporation',
  fiingroup: 'fiingroup.vn',
  notePDF:
    '<strong>*Disclaimer:</strong> FiinGroup will not accept any liability for loss or damage as a result of reliance on the information provided above. Please be fully informed that the official number is not provided by FiinGroup but rather by companies, so the predicted number may not be accurate and should be considered for reference purpose only. FiinGroup does not  bear any responsibility for any losses you might incur as a result of using this data.',
  notePDFGroup2:
    '<strong>FIINGROUP CORPORATION</strong><br><strong>Headquarter:</strong> 10th Floor, Peakview Tower, 36 Hoang Cau, Dong Da District, Hanoi, Vietnam<br><strong>Ho Chi Minh City Branch:</strong> 3rd Floor, Profomilk Plaza Building, 51-53 Vo Van Tan St, Ward 6, Ho Chi Minh City<br>Email: fiingroup@fiingroup.vn',
  notePDFGroup3:
    '<strong>CUSTOMER SERVICE CENTER</strong><br><strong>Headquarter</strong> <br>Tel: (8424) - 3562 6962 - Ext: 103<br>Email: fiintrade@fiingroup.vn<br><strong>Ho Chi Minh City</strong><br>Tel: (8428) - 3933 3586 - Ext: 201<br>Email: fiintrade@fiingroup',
  titleFinancialPerformanceYear:
    'FINANCIAL PERFORMANCE: Financial statistics of {0} stock in 5 recent years ({1} - {2})',
  titleFinancialPerformanceQuater:
    'FINANCIAL PERFORMANCE: Financial statistics of {0} stock in 5 recent quaters ({1} - {2})',
  titleFinancialPerformance: 'FINANCIAL PERFORMANCE',
  unitPercentage: '%',
  formatCategory: "Q{0}'{1}",
  tableInfor: {
    unitMillion: ' M',
    unitBillion: ' Bn.',
    unitPercent: '%',
    foreignerRoom: 'Foreign Room',
    stateHolding: 'State Holdings (M)',
    ForeignHoldings: 'Foreign Holdings',
    MajorHoldings: 'Major Holdings',
    ROE: 'ROE (%)',
    DE: 'D/E (time)',
    YRange: '1Y Range (Thousand VND)',
    CEO: 'CEO',
    Competitors: 'Competitors',
    marketCap: 'MarketCap (Billion VND)',
    AvgDailyVol: 'Avg. Daily Vol 1M',
    LastestDiv: 'Latest DIV (VND)',
    OutShare: 'Outstanding Shares (M)',
    PE: 'P/E (time)',
    PB: 'P/B',
    EPS: 'EPS (VND)',
    EPSForward: 'EPS Forward (VND)',
    FreeFloat: 'Free Float',
    StateHoldings: 'State Holdings',
    ROA: 'ROA (%)',
    foreignHolding: 'Foreign Holdings (M)',
    totalForeignRoom: 'Total Foreign Room (M)',
    foreignRoom: 'Foreign Room (M)',
    freeFloat: 'FreeFloat (M)',
  },
  chartTickerTooltip: {
    value: 'Value: ',
    volume: 'Volume: ',
  },
  chartNonBank: {
    chartRevenue: {
      title: 'Revenue',
      yAxis1Title: 'Billion VND',
      yAxis2Title: 'Times',
      tooltipNetSales: 'Net Sales {0}: {1} Bn.',
      tooltipAssetTurnover: 'Asset Turnover {0}: {1}',
      tooltipFixedAssetTurnover: 'Fixed Asset Turnover {0}: {1}',
      legendNetSales: 'Net Sales',
      legendAssetTurnover: 'Asset Turnover',
      legendFixedAssetTurnover: 'Fixed Asset Turnover',
    },
    chartProfit: {
      title: 'PROFIT',
      yAxis1Title: 'Billion VND',
      yAxis2Title: 'Percentage (%)',
      tooltipNetProfit: 'Net Profit {0}: {1} Bn.',
      tooltipGrossProfitMargin: 'Gross Profit Margin {0}: {1} %',
      tooltipEBITMargin: 'EBIT Margin {0}: {1} %',
      tooltipNetProfitMargin: 'Net Profit Margin {0}: {1} %',
      legendNetProfit: 'Net Profit',
      legendGrossProfitMargin: 'Gross Profit Margin',
      legendEBITMargin: 'EBIT Margin',
      legendNetProfitMargin: 'Net Profit Margin',
    },
    chartCashFlow: {
      title: 'CASH FLOW',
      yAxis1Title: 'Billion VND',
      yAxis2Title: 'Percentage',
      legendCFO: 'CFO',
      legendNCFF: 'CFF',
      legendNCFI: 'CFI',
      tooltipCFO: 'Net Cash Operating {0}: {1} Bn.',
      tooltipNCFF: 'Net Cash from Financing {0}: {1} Bn.',
      tooltipNCFI: 'Net Cash from Investing {0}: {1} Bn.',
    },
    chartLiquidityRatio: {
      title: 'Liquidity Ratio (TTM)',
      yAxis1Title: 'Times',
      tooltipCurrentRatio: 'Current Ratio {0}: {1}',
      tooltipQuickRatio: 'Quick Ratio {0}: {1}',
      tooltipCashRatio: 'Cash Ratio {0}: {1}',
      legendCurrentRatio: 'Current Ratio ',
      legendQuickRatio: 'Quick Ratio ',
      legendCashRatio: 'Cash Ratio ',
    },
    chartTotalAssset: {
      title: 'TOTAL ASSET',
      yAxis1Title: 'Billion VND',
      tooltipShortTermAsset: 'Short-term Asset {0}: {1} Bn.',
      tooltipLongTermAsset: 'Long-term Asset {0}: {1} Bn.',
      legendShortTermAsset: 'Short-term Asset ',
      legendLongTermAsset: 'Long-term Asset ',
    },
    chartTotalLiability: {
      title: 'TOTAL LIABILITY',
      yAxis1Title: 'Billion VND',
      yAxis2Title: 'Percentage',
      tooltipLiabilities: 'Liabilities {0}: {1} Bn.',
      tooltipEquityOwner: 'Equity Owner {0}: {1} Bn.',
      legendLiabilities: 'Liabilities ',
      legendEquityOwner: 'Equity Owner ',
      legendCharterCapital: 'Charter Capital ',
    },
    chartCapitalStructure: {
      title: 'CAPITAL STRUCTURE RATIO',
      yAxis1Title: 'Times',
      tooltipDebt: 'Debt/Equity {0}: {1} times',
      tooltipLTBorrwing: '(ST+ LT borrowings)/Equity {0}: {1} times',
      legendDebt: 'Debt/Equity',
      legendLTBorrwing: '(ST+ LT borrowings)/Equity',
    },
    chartOperating: {
      title: 'OPERATING RATIO',
      yAxis1Title: 'Days',
      tooltipCashCycle: 'Cash cycle {0}: {1}',
      tooltipDaysSaleOutstanding: 'Days Sales Outstanding {0}: {1}',
      tooltipDaysPayableOutstanding: 'Days Payable Outstanding {0}: {1}',
      tooltipDaysInventoryOutstanding: 'Days Inventory Outstanding {0}: {1}',
      legendCashCycle: 'Cash cycle',
      legendDaysSaleOutstanding: 'Days Sales Outstanding',
      legendDaysPayableOutstandingOutstanding: 'Days Payable Outstanding',
      legendDaysInventoryOutstanding: 'Days Inventory Outstanding',
    },
    chartReturnOnCapital: {
      title: 'RETURN ON CAPITAL',
      yAxis1Title: 'Percentage (%)',
      tooltipROE: 'ROE {0}: {1} %',
      tooltipROIC: 'ROIC {0}: {1} %',
      legendROE: 'ROE',
      legendROIC: 'ROIC',
    },
    chartOperatingCashFlow: {
      title: 'OPERATING CASH FLOW',
      yAxis1Title: 'Billion VND',
      tooltipCFO: 'CFO {0}: {1} Bn.',
      tooltipReceivable: '{2} Receivable {0}: {1} Bn.',
      tooltipPayable: '{2} Payable {0}: {1} Bn.',
      tooltipInventory: '{2} Inventory {0}: {1} Bn.',
      legendCFO: 'CFO',
      legendReceivable: '%{prefix} Receivable',
      legendPayable: '%{prefix} Payable',
      legendInventory: '%{prefix} Inventory',
    },
    chartDupont: {
      title: 'DUPONT',
      yAxis1Title: 'Percentage (%)',
      yAxis2Title: 'Times',
      tooltipROE: 'ROE {0}: {1} %',
      tooltipNetProfitMargin: 'Net Profit Margin {0} TTM: {1} %',
      tooltipFinancialLeverage: 'Financial Leverage {0}: {1}',
      tooltipAssetTurnover: 'Asset Turnover {0} TTM: {1}',
      legendROE: 'ROE',
      legendNetProfitMargin: 'Net Profit Margin TTM',
      legendFinancialLeverage: 'Financial Leverage',
      legendAssetTurnover: 'Asset Turnover TTM',
    },
  },
  chartBank: {
    chartNetInterestIncome: {
      title: 'NET INTEREST INCOME',
      yAxis1Title: 'NII (Thousand of Billion VND)',
      yAxis2Title: 'NIM (%)',
      tooltipNII: 'Net Interest Income {0}: {1} Tril.',
      tooltipNIM: 'Net Interest Margin {0}: {1}%',
      legendNII: 'Net Interest Income ',
      legendNIM: 'Net Interest Margin ',
    },
    chartNetProfit: {
      title: 'Net Profit ',
      yAxis1Title: 'Thousand of Billion VND',
      yAxis2Title: 'Growth (%)',
      tooltipNetProfit: 'Net Profit {0}: {1} Tril.',
      tooltipGrowth: 'Growth {0}: {1}%',
      legendNetProfit: 'Net Profit ',
      legendGrowth: 'Growth ',
    },
    chartBankTotalAsset: {
      title: 'TOTAL ASSET',
      yAxis1Title: 'Thousand of Billion VND',
      yAxis2Title: 'Growth (%)',
      legendTotalAsset: 'Total Asset',
      legendGrowth: 'Growth',
      tooltipTotalAsset: 'Total Asset {0}: {1} Tril.',
      tooltipGrowth: 'Growth {0}: {1}%',
    },
    chartBadDebt: {
      title: 'Bad Debt (TTM)',
      yAxis1Title: 'Value (Thousand of Billion VND)',
      yAxis2Title: 'Bad Debt Ratio (%)',
      tooltipBadDebtValue: 'Value {0}: {1} Tril.',
      tooltipBadDebtRatio: 'Bad Debt Ratio {0}: {1}%',
      legendBadDebtValue: 'Value',
      legendBadDebtRatio: 'Bad Debt Ratio',
    },
    chartTotalCredit: {
      title: 'Total Loan',
      yAxis1Title: 'TC (Thousand of Billion VND)',
      yAxis2Title: 'Growth (%)',
      tooltipLoans: 'Total Credit {0}: {1} Tril.',
      tooltipGrowth: 'Growth {0}: {1}%',
      legendLoans: 'Total Loan',
      legendGrowth: 'Growth ',
    },
    chartTotalDeposit: {
      title: 'TOTAL DEPOSIT',
      yAxis1Title: 'TD (Thousand of Billion VND)',
      yAxis2Title: 'Growth (%)',
      tooltipDeposit: 'Total Deposit {0}: {1} Tril.',
      tooltipGrowth: 'Growth {0}: {1}%',
      legendDeposit: 'Total Deposit ',
      legendGrowth: 'Growth ',
    },
  },
};
